import React from "react";
import AboutUs from "./AboutUs";
import OurTeam from "./OurTeam";
import WhyUs from "./WhyUs";

const About = () => {
  return (
    <React.Fragment>
      <WhyUs/>
      <AboutUs />
      <OurTeam />
    </React.Fragment>
  );
};

export default About;
